import { useEffect, useState} from 'react';
const backend = 'https://backend.lorenzo-viganego.com/';
const localhost = 'http://localhost:3000/'

function FetchImage (salad) {
  const [data, setData] = useState({});

  useEffect(() => {
    let isMounted = true;
    const arrayLength = salad.length;
    
    const request = async () =>  {
    let quantity = 0;
    salad.forEach(ingredient => {
      quantity+= ingredient.quantity
    })
    try {

    const getImage = (arrayLength, quantity) => {
      if (arrayLength == 1 || quantity == 1) {
        return 'https://i.ibb.co/syWTKJt/salad1.jpg'
      } else if (arrayLength == 2 || quantity == 2) {
        return 'https://i.ibb.co/DVD3Lk2/salad2.jpg'
      } else if (arrayLength == 3 || quantity == 3) {
        return 'https://i.ibb.co/4jsYNN0/salad3.jpg'
      } else if (arrayLength == 4 || quantity == 4) {
        return 'https://i.ibb.co/2jMfRJV/salad4.webp'
      } else if (arrayLength == 5 || quantity == 5) {
        return 'https://i.ibb.co/1zcqsdw/salad5.jpg'
      } else if (arrayLength == 6 || quantity == 6) {
        return 'https://i.ibb.co/QkZDDYs/salad6.jpg'
      }
    }

/*     const response = await fetch(`${backend}saladimages/`, {
      method: "POST",
      body: JSON.stringify({
        arrayLength: arrayLength,
        quantity: quantity
      }), 
      headers: {
        "Content-Type": "application/json"}
    } ); */

    const url = getImage(arrayLength, quantity)
    if (url) {
      console.log(url)
      setData({url, quantity});
    } else {

    }
  } catch(error) {
    console.error(error)
  }
  }

  if (salad[0] != 'first') {
    request() 
  }

  return () => isMounted = false;
  
  }, [salad])

  return [data]
}

export default FetchImage;